'use client';

import { JobportalOffersFilterParamsSync } from '@eliadmin/core/src/stores/jobportal-offers-store';
import { JobportalOffersStoreProvider } from '@eliadmin/core/src/stores/jobportal-offers-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { JobPortalOffersContentInner } from '@eliadmin/core/src/components/jobportal/offers/jobportal-offers-content-inner';

export default function JobPortalOffersContent() {
  const generalLayout = useGlobalStore(s => s.generalLayout);

  return (
    <>
      <JobportalOffersStoreProvider
        state={{
          orderBy: 'id',
          order: 'desc',
          results: generalLayout?.pagination?.paginationProducts || 12,
        }}
      >
        <JobportalOffersFilterParamsSync />
        <JobPortalOffersContentInner />
      </JobportalOffersStoreProvider>
    </>
  );
}
